import { VideoReelCommentModel, VideoReelModel, VideoReelReplyCommentModel } from "@/models"

export type VideoReelsType = {
  edges: VideoReelModel[];
  count: number;
};

export type VideoReelFilter = {
  limit?: number;
  offset?: number;
  created_at_from?: string;
  created_at_to?: string;
  staff_id?: number;
  sort_by?: string;
  sort?: string;
};

export const VideoReelsDefault: VideoReelsType = {
  edges: [],
  count: 0,
};

export type VideoReelsQueryPayload = VideoReelFilter;

export type VideoReelsQueryResponse = {
  data: VideoReelModel[];
  total_records: number;
};

export type VideoReelQueryResponse = { data: VideoReelModel };

export type CommentsQueryPayload = {
  reelId: number;
  params: {
    limit?: number;
    offset?: number;
    sort_by?: string;
    sort?: string;
    reply_limit?: number;
  }
};

export type CommentsQueryResponse = {
  data: VideoReelCommentModel[];
  total_records: number;
};

export type ReplyCommentsQueryPayload = {
  commentId: number;
  params: any;
};

export type ReplyCommentsQueryResponse = {
  data: VideoReelReplyCommentModel[];
  total_records: number;
};

export type CommentPayload = {
  comment: string;
  images?: any;
};

export type CreateCommentPayload = {
  reelId: number;
  body: CommentPayload;
};

export type UpdateCommentPayload = {
  commentId: number;
  body: CommentPayload;
};

export type CreateReplyCommentPayload = {
  commentId: number;
  body: CommentPayload;
};

export type UpdateReplyCommentPayload = {
  commentId: number;
  body: CommentPayload;
};

export type ReducerType = {
  data: VideoReelsType,
  filters: VideoReelFilter;
};

export enum ActionType {
  OnLoadMore = 'OnLoadMore',
  SetData = 'SetData',
  AppendData = 'AppendData',
  UpdateVideo = 'UpdateVideo',
  ToggleLike = 'ToggleLike',
};

export type ReducerAction =
  | { type: ActionType.OnLoadMore; payload: { limit?: number, offset: number }; }
  | { type: ActionType.SetData; payload: VideoReelsType; }
  | { type: ActionType.AppendData; payload: VideoReelsType; }
  | { type: ActionType.UpdateVideo; payload: VideoReelModel; }
  | { type: ActionType.ToggleLike; payload: VideoReelModel; }

export const videoReelsQueryBuilder = (filters: any) => {
  const {
    limit,
    offset,
    created_at_from,
    created_at_to,
    staff_id,
    sort_by,
    sort,
  } = filters;

  let payload = {};

  payload = {
    ...payload,
    limit,
    offset,
    created_at_from,
    created_at_to,
    staff_id,
    sort_by,
    sort,
  };

  return payload;
};

export const FormChatDefault = { comment: '' };